import React, {useEffect, useState} from 'react';

// custom components
import {Footer, Text, PageNavigator } from '../../components/atoms';
import { ApiTitle, TabList, List, TableNumber, Callout, RequestHeader, RequestFields, HttpRequest} from '../../components/molecules';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import SwaggerUI from "swagger-ui-react";

// custom components //
import { Maintenance } from '../../components/atoms';

// code
import sample from '../../utils/code/postBookingBody';
import { CopyBlock, dracula} from "react-code-blocks";

// utils
import { Colors } from '../../styles';

const codeStyle = {
    fontFamily: 'monospace',
    fontSize: 16,
    backgroundColor: '#f0f0f0',
    color: "#000000",
    padding: 4,
    borderRadius: 4
};

const GettingABooking = (props) => {

    const [tab, setTab] = useState(0)

    useEffect(() => {

    }, []);

    const TitleText = (props) => { return ( <p style={{ fontWeight:'bold', fontSize:14 }}>{props.children}</p>)}
    const TextText = (props) => { return ( <p style={{ fontWeight:'300', fontSize:14 }}>{props.children}</p>)}

    const ExampleBookingTable = (props) => {

        const Row = (props) => { return (
            <tr>
                <td><TitleText>{props.data}</TitleText></td>
                <td><TextText>{props.example}</TextText></td>
            </tr>
        )}

        return (
            <div style={{ }}>
                <table class="table" style={{ }}>
                        <thead style={{}}>
                            <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                                <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col">Data</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col">Value</th>
                            </tr>
                        </thead>
                    <tbody>
                        <tr>
                            <td><TitleText>{'Booking Id'}</TitleText></td>
                            <td><TextText>{'EI205-2022-01-01-joe-bloggs'}</TextText></td>
                        </tr>
                        <Row data={'Passenger Name'} description={'The name of the passenger'} example={'Mr. Joe Bloggs'} required={'Yes'} />
                        <Row data={'Reference Number'} description={'The reference number of the booking'} example={'JWTR617'} required={'Yes'} />
                        <Row data={'Origin Airport IATA'} description={'The IATA code of the origin airport'} example={'DUB'} required={'Yes'} />
                        <Row data={'Destination Airport IATA'} description={'The IATA code of the destination airport'} example={'JFK'} required={'Yes'} />
                        <Row data={'Flight Number'} description={'The flight number of the route'} example={'EI105'} required={'Yes'} />
                        <Row data={'Departure Date'} description={'The departure date of the flight'} example={'07-12-2022'} required={'Yes'} />
                        <Row data={'Assistance Requested'} description={'A list of SSR codes.'} example={'[ Wheelchair Access, Impaired Eyesight]'} required={'Yes'} />
                        <Row data={'Equipment Information'} description={'Details of the passengers wheelchair equipment'} example={'Make, Model, Weight, Battery etc.'} required={'Optional'} />
                        <Row data={'Service Animal'} description={'Wether or not the passenger is accomponanied by a service animal'} example={'False'} required={'Optional'} />
                    </tbody>
                </table>
            </div>
        )
    }

    const ResponseTable = (props) => {
        return (
            <div>
                <table class="table" style={{ }}>
                    <thead style={{}}>
                        <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                            <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col"><Text.TableHeader>Code</Text.TableHeader></th>
                            <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col"><Text.TableHeader>Description</Text.TableHeader></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>200 Ok</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Returns the queried booking. This booking will have the same fields as it was posted along with a supplementary _id field, a unique identifier generated on post.'}</Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>400 Bad Request</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>Indicates that there was an error in the request. </Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>403 Unauthorized Access</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Indicates that the request is unauthorized. Typically the result of not including the Authorization header in the request.'}</Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>500 Internal Server Error</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Indicates that the request did not go through due to an internal error.'}</Text.TableBody></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    return (
        <>
            {/* Title and Prerequisities */}
            <Row className='mt-5'>
                <Col>
                    <ApiTitle 
                        smallTitle={'GET Request'}
                        title={'Getting a booking'}
                        subtitle={'Use this guide to learn how to get PRM bookings from our database.'}
                        prerequisites={[
                            'JSON Web Token',
                            'Booking ID'
                        ]}
                        callout={<Callout title={'Getting Multiple Bookings'} subtitle={<p>This guide focuses on retrieving a single booking using a unique identifier, if you aim to retrieve multiple bookings filtered using airline, inbound, outbound and the date try the <a href={'/getting-bookings'}>Getting Multiple Bookings Guide.</a></p>} />}
                    />
                </Col>
            </Row>

            {/* Overview */}
            <Row>
                <Col>
                    <Text.Subheading>Overview</Text.Subheading>
                    <Text.Text>{`In this section, we aim to retrieve bookings using the PRM Connect Databse. This enables access to bookings received from our mobile app, our airport portal and from travel agents. Enabling access to these bookings ensures that there are more pre-notified passengers, reducing delays to a minimum and improving passenger service.`}</Text.Text>
                </Col>
            </Row>
            
            {/* Selector Tab List */}
            <Row>
                <Col>
                    <TabList 
                        tabs={['Overview', 'Example', 'Implementation']}
                        setTab={(value)=>{ setTab(value)}}
                    />
                </Col>
            </Row>

            { tab == 1 && 
            <>
            <Row className='mt-4'>
                <Col>
                    <Container>
                        <Text.Subheading>1. Authorization</Text.Subheading>
                        <Text.Text>{'Authentication is achieved by means of a JSON Web Token: '}</Text.Text>
                        <Container>
                            <List list={['Bearer <token>']} />
                        </Container>
                    </Container>
                </Col>
            </Row>

            {/* 2. Booking Information */}
            <Row className='mt-4'>
                <Col>
                    <Container>
                        <Text.Subheading>2. Booking Information</Text.Subheading>
                        <Text.Text>{'In order to get a specific booking using PRM Connect, a unique id must be used to retrieve the booking. This unique id is typically made up of '}</Text.Text>
                        <Container>
                            <List list={['Flight Number', 'Flight Date', 'Passenger Name']} />
                        </Container>    
                        <Text.Text>The table and code below show a typical booking object, examine the <span style={{fontStyle: "bold"}}>Booking Id</span> in 2.1 and the <span style={codeStyle}>_id</span> in 2.2</Text.Text>                
                    </Container>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col>
                    <Container>
                        <TableNumber title={'2.1 Booking'} description={'Example of a booking stored in the database'} />
                        <ExampleBookingTable />
                    </Container>
                </Col>
                <Col>
                    <Container>
                        <TableNumber title={'2.2 Example JSON'} description={'Example of a booking response from the database'} />
                        <CopyBlock
                            language={'json'}
                            text={sample['exampleBookingDatabase']}
                            showLineNumbers={false}
                            theme={dracula}
                            wrapLines={false}
                        />
                    </Container>
                </Col>
            </Row>

            {/* 3. Request */}
            <Row className='mt-5'>
                <Col>
                    <Container>
                        <Text.Subheading>3. Request</Text.Subheading>
                        <Text.Text>{'This section describes the Get Booking API with a detailed API structure, an example request and response, JSON schemas for request, responses and error response codes.'}</Text.Text>              
                    </Container>
                </Col>
            </Row>
            
            {/* 3.1 Headers */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.1 Header</Text.Subheading>
                        <Text.Text>{'The request contains the following headers:'}</Text.Text>
                        <RequestHeader />
                    </Container>
                </Col>
            </Row>

            {/* 3.2 Fields of Request */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.1 Fields of Request</Text.Subheading>
                        <Text.Text>{'The request contains the following fields:'}</Text.Text>
                        <RequestFields rows={[
                            { parameter:'id', description:'The id of the booking to return', example:'EI205-2022-01-01-joe-bloggs', optional:'Required'}
                        ]}
                        />
                    </Container>
                </Col>
            </Row>

            {/* 3.2 Body */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.2 Request Body</Text.Subheading>
                        <Text.Text>{'The request body is empty.'}</Text.Text>
                    </Container>
                </Col>
            </Row>

            {/* 3.3 Response */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.3 Request Response</Text.Subheading>
                        <Text.Text>{'This section reviews the different responses and their meaning.'}</Text.Text>
                        <ResponseTable />
                    </Container>
                </Col>
            </Row>
            </>
            }

            { tab == 2 &&
            <>
            <Row className='mt-4'>
                <Col >
                   <Container>

                       {/* Text */}
                       <Text.Subheading>1. Example Request</Text.Subheading>
                       <Text.Text>{'This section contains an example of requesting a passenger booking using the booking id.'}</Text.Text>

                       <Text.Subsubheading>1.1 Getting a single booking</Text.Subsubheading>
                       <Text.Text>{'In this example we get a single booking for a passenger, Joe Bloggs.'}</Text.Text>
                       
                       <Text.Subsubheading>1.1.1 Request</Text.Subsubheading>
                       <HttpRequest 
                            requestType={'GET'}
                            url={'https://connect.prmassist.com/api/v1/bookings/EI205-2022-01-01-joe-bloggs'}
                            headers={['Authorization: Bearer <token>', 'Content-Type: application/json']}
                        />
                   </Container>
               </Col>
           </Row>
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <TableNumber title={'1.1 Request Response'} description={'Displays the response from the above request'} />
                        <CopyBlock
                            language={'json'}
                            text={sample['exampleBookingDatabase']}
                            showLineNumbers={false}
                            theme={dracula}
                            wrapLines={false}
                        />
                    </Container>
                </Col>
            </Row>
            </>
            }

            {/* Request */}
            { tab === 3 &&
            <>
                <Row className='mt-4'>
                    <Col>
                        <Container>
                            <Text.Subheading>Swagger Implementation</Text.Subheading>
                            <Text.Text>{'This section contains a swagger that can be used for getting a single booking using a booking id, reviewing the different responses and error codes'}</Text.Text>
                            <SwaggerUI url="get_single_booking.yaml" />
                        </Container>
                    </Col>
                </Row>
            </>
            }

            {/* Page Navigator */}
            <Row>
                <Col>
                    <Container>
                        <PageNavigator leftText={''} leftLink={''} left={false}  rightText={'Get Multiple Bookings'} rightLink={'/getting-bookings'} />
                    </Container>
                </Col>
            </Row>
            
            <Footer small={true} />
        </>
    );
};

export default GettingABooking;
